// extracted by mini-css-extract-plugin
module.exports = {"start-menu":"start-menu-module--start-menu--ObWJY","start-menu_button":"start-menu-module--start-menu_button--18X3H"};